import React from "react";
import PropTypes from "prop-types";
import { load } from "actions/needHelpArticleActions";

// Redux
import { connect } from "react-redux";

class NeedHelpArticle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      param: "",
      articleId: props.match.params.articleId,
      response: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }

  componentDidMount() {
    this.handleLoad();
  }

  handleLoad(e) {
    if (e) {
      e.preventDefault();
    }

    this.props.dispatch(load({ articleId: this.state.articleId }));
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { error, response } = this.props;

    return (
      <form>
        {response
          ? <h3 dangerouslySetInnerHTML={{ __html: response.summary }} />
          : <div />}
        {response
          ? <div dangerouslySetInnerHTML={{ __html: response.body }} />
          : <div />}
        {error
          ? <p>
              {error.message}
            </p>
          : null}
      </form>
    );
  }
}

NeedHelpArticle.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.object,
  response: PropTypes.object,
  params: PropTypes.object,
  articleId: PropTypes.string,
};

const mapStateToProps = function(store) {
  return {
    error: store.error,
    response: store.needHelpArticle.response,
  };
};

export default connect(mapStateToProps)(NeedHelpArticle);



// WEBPACK FOOTER //
// ./components/employee/needHelpArticle.jsx